var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 5.0625C20.0813 5.0625 20.25 4.89375 20.25 4.6875V0.375C20.25 0.16875 20.0813 0 19.875 0H15.5625C15.3562 0 15.1875 0.16875 15.1875 0.375V1.6875H5.0625V0.375C5.0625 0.16875 4.89375 0 4.6875 0H0.375C0.16875 0 0 0.16875 0 0.375V4.6875C0 4.89375 0.16875 5.0625 0.375 5.0625H1.6875V14.6875H0.375C0.16875 14.6875 0 14.8562 0 15.0625V19.375C0 19.5813 0.16875 19.75 0.375 19.75H4.6875C4.89375 19.75 5.0625 19.5813 5.0625 19.375V18.0625H15.1875V19.375C15.1875 19.5813 15.3562 19.75 15.5625 19.75H19.875C20.0813 19.75 20.25 19.5813 20.25 19.375V15.0625C20.25 14.8562 20.0813 14.6875 19.875 14.6875H18.5625V5.0625H19.875ZM16.6875 1.5H18.75V3.5625H16.6875V1.5ZM1.5 3.5625V1.5H3.5625V3.5625H1.5ZM3.5625 18.25H1.5V16.1875H3.5625V18.25ZM18.75 16.1875V18.25H16.6875V16.1875H18.75ZM16.875 14.6875H15.5625C15.3562 14.6875 15.1875 14.8562 15.1875 15.0625V16.375H5.0625V15.0625C5.0625 14.8562 4.89375 14.6875 4.6875 14.6875H3.375V5.0625H4.6875C4.89375 5.0625 5.0625 4.89375 5.0625 4.6875V3.375H15.1875V4.6875C15.1875 4.89375 15.3562 5.0625 15.5625 5.0625H16.875V14.6875Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAoi);
export default __webpack_public_path__ + "static/media/aoi.b29bc013d3c90513fde730bc25f3a941.svg";
export { ForwardRef as ReactComponent };